import React from 'react';
import { Eye, MessageSquare, BarChart3 } from 'lucide-react';

const COACHING_MODES = [
  { id: 'awareness', icon: Eye, label: 'I want to understand what I\'m eating', desc: 'Track your meals and see your macros. No coaching suggestions, but you\'ll still get motivational moments.', accent: '#4A90D9' },
  { id: 'coaching', icon: MessageSquare, label: 'I want suggestions for healthier choices', desc: 'Get personalized tips after each meal, smart swaps, and weekly AI reflections. Full coaching experience.', accent: '#6B9E8A' },
  { id: 'data_only', icon: BarChart3, label: 'Just track \u2014 no coaching', desc: 'Pure data tracking. No suggestions, no motivational moments, no nudges. Just the numbers.', accent: '#E5A84B' },
];

export const CoachingModeStep = ({ formData, setFormData }) => (
  <div className="space-y-4 max-w-md mx-auto">
    {COACHING_MODES.map(c => (
      <button
        key={c.id}
        data-testid={`coaching-${c.id}`}
        onClick={() => setFormData(p => ({ ...p, coaching_mode: c.id }))}
        className={`w-full p-6 rounded-2xl text-left transition-all border-2 flex items-start gap-4 ${
          formData.coaching_mode === c.id
            ? 'border-[#1A3A4A] dark:border-[#6B9E8A] bg-[#1A3A4A]/5 dark:bg-[#6B9E8A]/10'
            : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 hover:border-[#1A3A4A]/20'
        } shadow-sm`}
      >
        <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: `${c.accent}15` }}>
          <c.icon className="w-6 h-6" style={{ color: c.accent }} />
        </div>
        <div>
          <h3 className="font-semibold text-[#1A3A4A] dark:text-[#F0EDE8]">{c.label}</h3>
          <p className="text-sm text-[#7A7A72] dark:text-[#A1A1AA] mt-1 leading-relaxed">{c.desc}</p>
        </div>
      </button>
    ))}
  </div>
);
